// extracted by mini-css-extract-plugin
module.exports = {"button":"AddEditObjectiveDialog_button__39sHC","title":"AddEditObjectiveDialog_title__3JGRk","resetBtn":"AddEditObjectiveDialog_resetBtn__LaURc"};